var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnhang = function SvgAnhang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.5 5v11.5a4 4 0 0 1-8 0V4a2.5 2.5 0 0 1 5 0v10.5a1 1 0 0 1-2 0V5H3v9.5a2.5 2.5 0 0 0 5 0V4a4 4 0 0 0-8 0v12.5a5.5 5.5 0 0 0 11 0V5Z"
  })));
};
export default SvgAnhang;